/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('form', ['ngFileUpload', 'form.date-picker']);